import { render, staticRenderFns } from "./KSelect.vue?vue&type=template&id=0f09a909&"
import script from "./KSelect.vue?vue&type=script&lang=js&"
export * from "./KSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports